<script>
    import { createEventDispatcher } from "svelte";
    import { fade, scale } from "svelte/transition";
  
    const dispatch = createEventDispatcher();
  
    function closeOverlay() {
      dispatch("close");
    }
  </script>
  
  <div 
    class="howto-overlay" 
    on:click={closeOverlay} 
    transition:fade={{ duration: 300 }}
  >
    <div 
      class="howto-dialog" 
      on:click|stopPropagation 
      transition:scale={{ duration: 300 }}
    >
      <h2>How to Use AI Cloaker</h2>
      <ul class="howto-list">
        <li>Upload your personal style sample (PDF or TXT) if you want to use My Style.</li>
        <li>Paste or type your original text into the input box.</li>
        <li>Select the cloak style from the dropdown (Generic is default).</li>
        <li>Click <strong>Rewrite</strong> to generate your cloaked version.</li>
        <li>Copy and use the text anywhere you want!</li>
      </ul>
      <p>When done, click outside the box or press the “X” below to close.</p>
      <button class="close-howto" on:click={closeOverlay}>X</button>
    </div>
  </div>
  
  <style>
    .howto-overlay {
      position: fixed;
      inset: 0;
      background: rgba(10, 11, 14, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999;
    }
    .howto-dialog {
      background: linear-gradient(135deg, #1c1e24, #2a2e39);
      border: 1px solid #424867;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
      border-radius: 10px;
      max-width: 550px;
      width: 90%;
      padding: 2rem;
      position: relative;
      text-align: left;
    }
    .howto-dialog h2 {
      margin-top: 0;
      margin-bottom: 1rem;
      font-size: 1.4rem;
      background: linear-gradient(120deg, #646cff, #ff6b6b);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .howto-list {
      list-style: none;
      margin: 0 0 1.5rem 0;
      padding: 0;
    }
    .howto-list li {
      line-height: 1.8;
      position: relative;
      margin-bottom: 0.8rem;
      padding-left: 1.5rem;
    }
    .howto-list li::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0.45rem;
      width: 0.6rem;
      height: 0.6rem;
      background: #646cff;
      border-radius: 50%;
    }
    .close-howto {
      position: absolute;
      top: 1rem;
      right: 1rem;
      background: #424867;
      color: #e2e8f0;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      padding: 0.3rem 0.6rem;
    }
    .close-howto:hover {
      background: #646cff;
    }
  </style>
  